import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-03/lesson-20/task-02";

const task: Slide = {
  title: "Connect Elements to correct answers.",
  description: "Connect with lines.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
